import { render, staticRenderFns } from "./KonvaEmbed.vue?vue&type=template&id=0d170d65&scoped=true&"
import script from "./KonvaEmbed.vue?vue&type=script&lang=ts&"
export * from "./KonvaEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./KonvaEmbed.vue?vue&type=style&index=0&id=0d170d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d170d65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems})
